module.exports = __webpack_public_path__ + "img/visionaries-card-three.a976a0e2.png";